/* MOMMYSLOVE - quick add (tarjetas "+" y tallas de las tarjetas) + red de seguridad del carrito lateral */
(function () {
  if (window.__mmlRecsBound) return;
  window.__mmlRecsBound = true;

  var DRAWER_ID = 'sidebar-cart';

  function drawerIsOpen() {
    var d = document.getElementById(DRAWER_ID);
    return !!d && d.getAttribute('aria-hidden') === 'false';
  }

  function flagAndReload() {
    try { sessionStorage.setItem('mmlOpenCart', '1'); } catch (e) {}
    window.location.reload();
  }

  /* ---------------------------------------------------------------
     Quick add: anade la variante y abre el carrito lateral
     (home, colecciones, recomendados y carrito).
     --------------------------------------------------------------- */
  function addToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function () { flagAndReload(); })
    .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (e) {
    /* Tallas de las tarjetas (home / colecciones) */
    var chip = e.target.closest('.MMLSz[data-variant-id]');
    if (chip) {
      e.preventDefault();
      e.stopPropagation();
      chip.classList.add('is-busy');
      addToCart(chip.dataset.variantId);
      return;
    }

    var add = e.target.closest('.MMLRecCard__Add');
    if (add) {
      e.preventDefault();
      var card = add.closest('.MMLRecCard');
      var sizes = card ? card.querySelector('.MMLRecCard__Sizes') : null;
      if (sizes) {
        document.querySelectorAll('.MMLRecCard__Sizes').forEach(function (s) {
          if (s !== sizes) s.hidden = true;
        });
        sizes.hidden = !sizes.hidden;
      } else if (add.dataset.variantId) {
        add.disabled = true;
        add.textContent = '…';
        addToCart(add.dataset.variantId);
      }
      return;
    }

    var size = e.target.closest('.MMLRecCard__Size');
    if (size) {
      e.preventDefault();
      size.textContent = '…';
      addToCart(size.dataset.variantId);
      return;
    }

    if (!e.target.closest('.MMLRecCard__Sizes')) {
      document.querySelectorAll('.MMLRecCard__Sizes').forEach(function (s) { s.hidden = true; });
    }
  });

  /* ---------------------------------------------------------------
     Red de seguridad: si al anadir desde la ficha de producto el tema
     no abre el carrito lateral, lo abrimos nosotros. Comprobamos
     cada 150ms durante 1,4s y salimos en cuanto se ha abierto solo.
     --------------------------------------------------------------- */
  document.addEventListener('product:added', function () {
    var waited = 0;
    var timer = setInterval(function () {
      if (drawerIsOpen()) { clearInterval(timer); return; }
      waited += 150;
      if (waited >= 1400) {
        clearInterval(timer);
        if (!drawerIsOpen()) flagAndReload();
      }
    }, 150);
  });

  /* ---------------------------------------------------------------
     Al recargar, si veniamos de anadir algo, abrimos el carrito.
     --------------------------------------------------------------- */
  function reopenCart() {
    var flag = null;
    try { flag = sessionStorage.getItem('mmlOpenCart'); } catch (e) {}
    if (!flag) return;
    try { sessionStorage.removeItem('mmlOpenCart'); } catch (e) {}
    var opener = document.querySelector('[data-action="open-drawer"][data-drawer-id="sidebar-cart"]');
    if (opener) setTimeout(function () { opener.click(); }, 350);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reopenCart);
  } else {
    reopenCart();
  }
})();
